export default "__VITE_ASSET__dIBSzk4I__"